module.exports = __webpack_public_path__ + "img/whoopsie-image-grey.755cdc0c.png";